import createUICardElement from "backend/utils/createUICardElement";
import * as wf from "client-api-workflow";
import { useQuery } from "react-query";

const useAllWorkflowInstances = (type: string, period: string) => {
  return useQuery(
    JSON.stringify(["data-all-workflow-instances", type, period]),
    () => {
      return wf
        .getAllInstances(type, period)
        .then((data) =>
          data.map((item) =>
            createUICardElement(item.wfInstanceId, "workflowinstance", item)
          )
        );
    },
    {
      cacheTime: 1 * 1000,
    }
  );
};

export default useAllWorkflowInstances;
